// Generated by CoffeeScript 1.12.7
(function () {
  'use strict'
  require('../base')

  require('../toggle_transition')

  $.widget('bijou.masthead', $.bijou.base, {
    _create: function () {
      this.breakpointEnabled()
      this.activeMenuItem = null
      this.noticeIsOpen = false
      this._fixPanelHeights()
      this._on(this.window, {
        resize: function () {
          if (this.resizeTimer) {
            clearTimeout(this.resizeTimer)
          }
          return (this.resizeTimer = setTimeout(
            (function (_this) {
              return function () {
                return _this._fixPanelHeights()
              }
            })(this),
            100
          ))
        }
      })
      this._on(this.document, {
        click: function (e) {
          if (e.button === 0) {
            return this.closeActiveSubmenu()
          }
        },
        keyup: function (e) {
          if (e.which === 27) {
            return this.closeActiveSubmenu()
          }
        }
      })
      return this._on(
        {
          'click .js-submenu': function (e) {
            return e.stopPropagation()
          },
          'click .js-menu-toggle': function (e) {
            $(e.currentTarget).attr('aria-expanded', function (i, attr) {
              if (attr === 'true') {
                return 'false'
              } else {
                return 'true'
              }
            })
            if (this.noticeIsOpen) {
              return this.toggleNoticeModal()
            } else {
              return this.element.toggleTransition(
                (function (_this) {
                  return function () {
                    return _this.element.toggleClass('menu--open')
                  }
                })(this)
              )
            }
          },
          'focusin .js-menu-panel': function (e) {
            var item
            item = $(e.currentTarget).closest('.js-submenu')
            if (!item.is(this.activeMenuItem)) {
              return this.toggleSubMenu(item)
            }
          },
          'click .js-submenu > a': function (e) {
            e.preventDefault()
            return this.toggleSubMenu(
              $(e.currentTarget).closest('.js-submenu')
            )
          }
        },
        (this.noticeModal = this.element.find('.js-notice-modal')).length === 1
          ? this._on({
            'click .js-notice-toggle': function (e) {
              e.preventDefault()
              return this.toggleNoticeModal()
            }
          })
          : void 0
      )
    },
    toggleSubMenu: function (item) {
      if (this.activeMenuItem) {
        this.activeMenuItem.removeClass('menu__item--active')
      }
      this.activeMenuItem = item.is(this.activeMenuItem)
        ? null
        : item.addClass('menu__item--active')
    },
    closeActiveSubmenu: function () {
      if (!this.activeMenuItem) {
        return
      }
      this.activeMenuItem.removeClass('menu__item--active')
      return (this.activeMenuItem = null)
    },
    toggleNoticeModal: function () {
      this.element.toggleClass('site-header--with-open-modal').toggleTransition(
        (function (_this) {
          return function () {
            $('body').toggleClass('has-open-modal')
            return _this.noticeModal.toggleClass('modal--open')
          }
        })(this)
      )
      return (this.noticeIsOpen = !this.noticeIsOpen)
    },
    _fixPanelHeights: function () {
      if (!(this.options.breakpoint === 'mobile' || 'tablet')) {
        return
      }
      return this.element.find('.js-menu-panel').each(function (_index, panel) {
        if (!$.bijou.transitionEvent) {
          return
        }
        return $(panel).parent().css('max-height', panel.scrollHeight)
      })
    }
  })
}.call(this))
